import { createContext, useContext } from "react";
import useLocalStorage from "../hooks/useLocalStorage";
import { OtpConfig } from "../types/otp-config";
import { Tariff } from "../types/subscription";

export type AuthType = {
    isLoggedIn: boolean;
}

export const CardContext = createContext<{
    otpConfig: OtpConfig;
    saveOtpConfig: (config: OtpConfig) => void;
    selectedTariff: Tariff | null;
    saveSelectedTariff: (tariff: Tariff | null) => void;
}>({
    otpConfig: {},
    saveOtpConfig: (config: OtpConfig) => { },
    selectedTariff: null,
    saveSelectedTariff: (tariff: Tariff | null) => { },
})

export const CardProvider = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    const [otpConfig, setOtpConfig] = useLocalStorage<OtpConfig>('otp-config', { id: undefined, source: undefined })
    const [selectedTariff, setSelectedTariff] = useLocalStorage<Tariff | null>('selected-tariff', null)

    const saveOtpConfig = (config: OtpConfig) => {
        setOtpConfig(config)
    }
    const saveSelectedTariff = (tariff: Tariff | null) => {
        setSelectedTariff(tariff)
    }
    return (
        <CardContext.Provider value={{ otpConfig, saveOtpConfig, selectedTariff, saveSelectedTariff }}>
            {children}
        </CardContext.Provider>
    )
}

export const useCard = () => useContext(CardContext);